import ForecastsAdjustmentsPage from 'src/components/BeaconV2Components/ExperimentalLayout/ForecastsAdjustmentsPage';
import GenericPageContainer from 'src/components/EntityPage/GenericPageContainer';

const getForecastsAdjustmentsLayout = () => {
  return {
    CustomPageContainer: GenericPageContainer,
    widgets: [
      {
        name: 'forecastsAdjustmentsLayout',
        CustomComponent: ForecastsAdjustmentsPage,
        view: {}
      }
    ],
    containerStyle: {},
    dataConfig: {}
  };
};

export default getForecastsAdjustmentsLayout;
